import { NgModule } from '@angular/core';
import { REMOVE_STYLES_ON_COMPONENT_DESTROY } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';

@NgModule({
  declarations: [AppComponent],
  imports: [CoreModule],
  bootstrap: [AppComponent],
  providers: [{ provide: REMOVE_STYLES_ON_COMPONENT_DESTROY, useValue: false }],
})
export class AppModule {}
